angular.module('MyApp')
    .service('GrupoDisciplinasService', ["Configs", "$resource", "$q" , "$http", function (Configs, $resource, $q, $http) {
      this.listarGrupoDisciplinas = function(codPessoa){
        let deferr = $q.defer();
         if (codPessoa) {
            $resource(Configs.getApiServer() + '/matricula/grupo-disciplinas?idPessoa=:codPessoa',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  codPessoa
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }
    }]);
